"use client";

import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Link from "next/link";
import Image from "next/image";

const services = [
  {
    title: "Individual Savings Solutions",
    image: "/projects/profile.jpg",
    description:
      "Personalized savings plans designed to help individuals build financial security and achieve their goals.",
    lists: [
      "Regular savings accounts",
      "Fixed deposit options",
      "Automatic savings plans",
    ],
    details:
      "Our savings solutions offer flexible deposit options, competitive interest rates, and easy access to your funds to support your financial growth and stability.",
  },
  {
    title: "Institutional Savings",
    image: "/projects/profile2.jpg",
    description:
      "Savings solutions tailored for organizations and institutions to manage funds effectively.",
    lists: [
      "Corporate savings accounts",
      "Reserve fund management",
      "Custom deposit schemes",
    ],
    details:
      "We provide flexible savings products with competitive rates and tailored features to help institutions maximize fund growth and liquidity management.",
  },
];

const otheryegna = [
  {
    title: "Agriculture Loan",
    description:
      "This loan will be availed to middle income farmer borrowers for purchasing agricultural inputs: like fertilizer, improved seed, land rent, purchase of oxen and for fattening activities.",
    image: "/projects/etege.png",
  },
  {
    title: "Special Emergency Loan",
    description:
      "This short-term credit is designed for businesses needing urgent financing, such as importers and contractors. Loans must be repaid within six months, with flexible repayment options: monthly, quarterly, or lump sum at maturity. It supports businesses with immediate financial needs and quick returns.",
    image: "/projects/profile3.jpg",
  },
  {
    title: "Urban Agriculture and Innovation Loan",
    description:
      "This loan supports agricultural activities in urban areas, including oxen, poultry, dairy, fattening, animal husbandry, irrigation, land rent, handicrafts, and beekeeping. The loan term ranges from 12 to 36 months, catering to small-scale farmers and agribusinesses.",
    image: "/projects/profile3.jpg",
  },
];

const projects = [
  {
    title: "Individual Voluntary Saving Account",
    description:
      "Account opened for eligible individual customer to save in Yegna MFI to get higher interest rate.This Saving account bears minimum interest rate of 8.5% per annum.",
    image: "/projects/individual.jpg",
  },
  {
    title: "Child Trust Saving Account (Minor)",
    description:
      "Account opened for children and youth below age of 18 years.Opened and operated by parents or guardian,This Saving account bears minimum interest rate of 9% per annum.",
    image: "/projects/childtrust.jpg",
  },
  {
    title: "Box Saving Account",
    description:
      "Account dedicated to encourage small savers in both urban and rural areas who do not have easy access to saving facilities.Box is distributed to savers to save at their home/ business areas,It bears 8.5% interest rate per annum.",
    image: "/projects/boxsaving40.jpg",
  },
  {
    title: "Women Saving Account",
    description:
      "Account dedicated to women eligible customers to empower women with attractive value prepositions.The minimum interest rate is 9%,The account holder women have a privilege to get Etege loan facility from Yegna Microfinance S.C.",
    image: "/projects/hero123412.jpg",
  },
];

// Clean color palette - Only Deep Teal Green and White
const colors = {
  primary: "#395750",      // Deep Teal Green - Company color
  primaryDark: "#2A423C",  // Darker teal
  primaryLight: "#4B6B63", // Lighter teal
  white: "#FFFFFF",        // White
  whiteOff: "#F8F9FA",     // Off-white for subtle contrast
  textDark: "#1A2E29",     // Dark text for contrast
};

const text = "Details of our services & solutions";

export default function ServiceindividualCards() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (currentIndex < text.length) {
      const timeout = setTimeout(() => {
        setCurrentIndex((prev) => prev + 1);
      }, 100);
      return () => clearTimeout(timeout);
    }
  }, [currentIndex]);

  return (
    <div className="mt-30 mb-20 space-y-16 pt-28 overflow-x-hidden sm:pt-10 md:pt-6 lg:pt-0">
      {/* Projects Section */}
      <div className="mt-20 px-4 lg:mx-auto lg:max-w-[1500px]" id="projects">
        <div className="py-3" style={{ backgroundColor: colors.white }}>
          <div className="relative">
            {/* Decorative elements */}
            <div className="absolute left-0 top-1/4 h-64 w-64 rounded-full opacity-50 blur-xl" style={{ backgroundColor: `${colors.primary}10` }}></div>
            <div className="absolute bottom-1/4 right-0 h-48 w-48 rounded-full opacity-20 blur-xl" style={{ backgroundColor: `${colors.primaryLight}30` }}></div>

            <div className="space-y-32">
              {projects.map((project, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  viewport={{ once: true, margin: "-100px" }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  className="relative z-10"
                >
                  {/* Floating number indicator */}
                  <motion.div
                    className="absolute -left-12 top-0 z-0 text-9xl font-bold opacity-30"
                    style={{ color: `${colors.primary}10` }}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2 }}
                  >
                    0{index + 1}
                  </motion.div>

                  <div
                    className={`flex flex-col ${index % 2 ? "md:flex-row-reverse" : "md:flex-row"} items-center gap-8 md:gap-12`}
                  >
                    {/* Image section */}
                    <motion.div
                      className="relative md:w-3/5"
                      initial={{ x: index % 2 ? 100 : -100, opacity: 0 }}
                      whileInView={{ x: 0, opacity: 1 }}
                      transition={{ duration: 0.6 }}
                    >
                      <div className="relative aspect-[16/7] overflow-hidden rounded-xl shadow-lg">
                        <Image
                          src={project.image}
                          alt={project.title}
                          fill
                          className="object-cover transition-transform duration-500 hover:scale-105"
                        />
                        <div className="absolute inset-0" style={{ background: `linear-gradient(to right, ${colors.primary}20, transparent)` }}></div>
                      </div>
                      <motion.div
                        className="absolute -bottom-4 -left-4 h-16 w-16 rounded-full"
                        style={{ backgroundColor: `${colors.primaryLight}20` }}
                        initial={{ scale: 0 }}
                        whileInView={{ scale: 1 }}
                        transition={{ delay: 0.4 }}
                      />
                    </motion.div>

                    {/* Content section */}
                    <motion.div
                      className="relative md:w-2/5"
                      initial={{ x: index % 2 ? -50 : 50, opacity: 0 }}
                      whileInView={{ x: 0, opacity: 1 }}
                      transition={{ duration: 0.6, delay: 0.3 }}
                    >
                      <div className={`${index % 2 ? "md:pr-8" : "md:pl-8"}`}>
                        <motion.h3
                          className="text-3xl font-bold"
                          style={{ color: colors.primary }}
                          initial={{ opacity: 0 }}
                          whileInView={{ opacity: 1 }}
                          transition={{ delay: 0.4 }}
                        >
                          {project.title}
                        </motion.h3>

                        <motion.div
                          className="my-4 h-1 w-16"
                          style={{ background: `linear-gradient(to right, ${colors.primary}, ${colors.primaryLight})` }}
                          initial={{ scaleX: 0 }}
                          whileInView={{ scaleX: 1 }}
                          transition={{ delay: 0.5 }}
                        />

                        <motion.p
                          className="mb-6 text-lg"
                          style={{ color: colors.textDark }}
                          initial={{ opacity: 0 }}
                          whileInView={{ opacity: 1 }}
                          transition={{ delay: 0.6 }}
                        >
                          {project.description}
                        </motion.p>
                      </div>
                    </motion.div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Yegna other unique loan section */}
      <div
        className="mt-20 px-4 lg:mx-auto lg:max-w-[1500px]"
        id="special-loans"
      ></div>
    </div>
  );
}